import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { ApiErrorMessage } from "@advosys/component-advosys-react";
import { DetailsList, FormHeader, Grow, StackLayout, useLocalStorageDetailsListState } from "@advosys/component-react";
import { useMatterLedgerEntriesColumns } from "./matter-ledger-entries-columns";
import { useT } from "./matter-ledger-entries-i18n";
import { actions } from "./matter-ledger-entries-store";
const mapStateToProps = (state) => state.dynamicInvoices.dynamicInvoicesPages.dynamicInvoicesPage.matterLedgerEntries;
const MatterLedgerEntriesBase = (props) => {
    const { t } = useT();
    const { columns } = useMatterLedgerEntriesColumns();
    const { detailsListState, saveColumnLayoutState } = useLocalStorageDetailsListState("MatterLedgerEntries-V2-689f65c4-e3d2-457f-bd3d-0912cbb05440", columns);
    const columnsLayout = useMemo(() => ({ columnLayoutStates: detailsListState.columnLayoutStates, onColumnsLayoutStateChanged: saveColumnLayoutState }), [detailsListState.columnLayoutStates, saveColumnLayoutState]);
    const getKey = useCallback(item => item.id.toString(), []);
    useEffect(() => {
        props.getMatterLedgerEntriesRequest(props.preparedInvoiceId);
        return () => {
            props.clearMatterLedgerEntries();
        };
    }, []);
    const matterLedgerEntries = props.loading.state === "has-finished" ? props.loading.data.matterLedgerEntries : [];
    return (_jsxs(StackLayout, { grow: Grow.Last, children: [_jsx(FormHeader, { children: t.listHeader }), props.loading.state === "failed" && _jsx(ApiErrorMessage, { message: props.loading.error }), _jsx(DetailsList, { columns: columns, columnsLayout: columnsLayout, items: matterLedgerEntries, getKey: getKey, enableShimmer: props.loading.state === "is-running" })] }));
};
export const MatterLedgerEntries = connect(mapStateToProps, actions)(MatterLedgerEntriesBase);
